// CommonCard component displays a card with entity details and actions (view, edit, delete) based on props
import React from "react";
import "../../static/css/CrewCard.css";
import EditIcon from "../../static/images/Editicon.svg";
import DeleteIcon from "../../static/images/Archive.svg";
import DetailsoverviewIcon from "../../static/svg/DetailsoverviewIcon";
import AccessControl from "../molecules/AccessControl";
interface CommonCardProps {
  id: string | number;
  title: string;
  details: { label: string; value: string | undefined }[];
  entityType: "Agent" | "Role" | "Flow";
  onView?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  permissionName?: string;
}

const CommonCard: React.FC<CommonCardProps> = ({
  id,
  title,
  details,
  entityType,
  onView,
  onEdit,
  onDelete,
  permissionName,
}) => {
  return (
    <div className="crew-card">
      <div className="crew-content">
        <div className="crew-card-image">
          <div className="user-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M4.5 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zM14.25 8.625a3.375 3.375 0 116.75 0 3.375 3.375 0 01-6.75 0zM1.5 19.125a7.125 7.125 0 0114.25 0v.003l-.001.119a.75.75 0 01-.363.63 13.067 13.067 0 01-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 01-.364-.63l-.001-.122zM17.25 19.128l-.001.144a2.25 2.25 0 01-.233.96 10.088 10.088 0 005.06-1.01.75.75 0 00.42-.643 4.875 4.875 0 00-6.957-4.611 8.586 8.586 0 011.71 5.157v.003z" />
            </svg>
          </div>
        </div>
        <div className="crew-description">
          <div className="crew-card-details">
            <h2>{title}</h2>
          </div>
          <div className="crew-button d-flex">
            {permissionName && 
              <>
                <AccessControl
                  requiredPermissions={[
                    {
                      permission: permissionName ,
                      types: ["read"],
                    },
                  ]}
                  renderNoAccess={<></>}
                >
                  {onView && (
                    <button
                      className="action-button me-3"
                      title="Details"
                      data-bs-toggle="tooltip"
                      onClick={onView}
                    >
                      <DetailsoverviewIcon />
                    </button>
                  )}
                </AccessControl>

                <AccessControl
                  requiredPermissions={[
                    {
                      permission: permissionName,
                      types: ["update"],
                    },
                  ]}
                  renderNoAccess={<></>}
                >
                  {onEdit && (
                    <button className="action-button" onClick={onEdit}>
                      <img
                        src={EditIcon}
                        alt="Edit"
                        title="Edit"
                        data-bs-toggle="tooltip"
                        className="icon me-3"
                      />
                    </button>
                  )}
                </AccessControl>

                <AccessControl
                  requiredPermissions={[
                    {
                      permission: permissionName,
                      types: ["delete"],
                    },
                  ]}
                  renderNoAccess={<></>}
                >
                  {onDelete && (
                    <button className="action-button" onClick={onDelete}>
                      <img
                        src={DeleteIcon}
                        alt="Delete"
                        title="Delete"
                        data-bs-toggle="tooltip"
                        className="icon"
                      />
                    </button>
                  )}
                </AccessControl>
              </>
            
            }
          </div>
        </div>
      </div>
      <hr className="divider" />
      <div className="crew-card-contents">
        {details.map((detail, index) => (
          <div className="info-item" key={index}>
            <p className="info-label">{detail.label}</p>
            <p className="info-value">{detail.value || "N/A"}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommonCard;
